import api from '~config/api';

const getSettings = () => api.get('v1/settings');

const getDefaultStoreId = () => api.get('v1/stores/default');

export default { getSettings, getDefaultStoreId };
